import React, { useState, useEffect } from 'react';
import {
  Box,
  Paper,
  Typography,
  Button,
  Stack,
  Link
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const CookieConsent = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // Vérifier si l'utilisateur a déjà fait un choix
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      // Attendre un peu avant d'afficher le modal pour une meilleure UX
      const timer = setTimeout(() => {
        setOpen(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setOpen(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setOpen(false);
  };

  if (!open) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        p: 2,
        pointerEvents: 'none'
      }}
    >
      <Paper
        elevation={24}
        sx={{
          maxWidth: 600,
          width: '100%',
          p: 3,
          pointerEvents: 'auto',
          borderRadius: 2,
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white'
        }}
      >
        <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
          🍪 Gestion des Cookies
        </Typography>
        <Typography variant="body2" sx={{ mb: 3, lineHeight: 1.6 }}>
          Nous utilisons des cookies pour améliorer votre expérience de navigation, analyser le trafic du site et personnaliser le contenu. 
          En continuant à utiliser notre site, vous acceptez notre utilisation des cookies. 
          <Link 
            href="/cookies" 
            onClick={(e) => {
              e.preventDefault();
              navigate('/cookies');
            }}
            sx={{ 
              color: 'white', 
              textDecoration: 'underline',
              ml: 0.5,
              '&:hover': { color: 'rgba(255, 255, 255, 0.8)' }
            }}
          >
            En savoir plus
          </Link>
        </Typography>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="flex-end">
          <Button
            variant="outlined"
            onClick={handleReject}
            sx={{
              borderColor: 'white',
              color: 'white',
              '&:hover': {
                borderColor: 'rgba(255, 255, 255, 0.8)',
                bgcolor: 'rgba(255, 255, 255, 0.1)'
              }
            }}
          >
            Refuser
          </Button>
          <Button
            variant="contained"
            onClick={handleAccept}
            sx={{
              bgcolor: 'white',
              color: 'primary.main',
              '&:hover': {
                bgcolor: 'rgba(255, 255, 255, 0.9)'
              }
            }}
          >
            Accepter
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
};

export default CookieConsent;

